import React, { useEffect, useState } from 'react';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';

import { useDispatch, useSelector } from 'react-redux';
import UsersRequests from 'services/users';
import TableHeading from './TableHeading';
import TableItem from './TableItem';
import { Box, Typography } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import { animateScroll as scroll } from 'react-scroll';

const AllUsersTable = () => {
  const dispatch = useDispatch();
  const { allUsers, allUsersTotalPages, allUsersCurrentPage, userSearchParams } = useSelector(({ users }) => users);
  const [searchMode, setSearchMode] = useState(false);

  useEffect(() => {
    dispatch(UsersRequests.getAllUsers(1));
  }, []);

  useEffect(() => {
    if (userSearchParams) {
      setSearchMode(true);
    } else {
      setSearchMode(false);
    }
  }, [userSearchParams]);

  useEffect(() => {
    if (searchMode) {
      dispatch(UsersRequests.searchAllUsers(1, userSearchParams));
    } else {
      dispatch(UsersRequests.getAllUsers(1));
    }
    if (!userSearchParams) {
      dispatch(UsersRequests.getAllUsers(1));
    }
  }, [searchMode, userSearchParams]);

  const handleChangePagination = (_, value) => {
    if (searchMode) {
      dispatch(UsersRequests.searchAllUsers(value, userSearchParams));
      scroll.scrollToTop();
    } else {
      dispatch(UsersRequests.getAllUsers(value));
      scroll.scrollToTop();
    }
  };

  return (
    <div className="Cmt-table-responsive">
      {allUsers &&
        (allUsers.length === 0 ? (
          <Box display={'flex'} justifyContent={'center'} paddingTop={'30px'} paddingBottom={'20px'}>
            <Typography variant="h3">موردی برای نمایش وجود ندارد</Typography>
          </Box>
        ) : (
          <Table>
            <TableHead>
              <TableHeading />
            </TableHead>
            <TableBody>
              {allUsers.map(user => (
                <TableItem user={user} key={user._id} />
              ))}
            </TableBody>
          </Table>
        ))}
      {allUsers.length !== 0 ? (
        <Box display={'flex'} justifyContent={'center'} marginTop={'20px'}>
          <Pagination
            count={allUsersTotalPages}
            color="primary"
            page={allUsersCurrentPage}
            onChange={handleChangePagination}
          />
        </Box>
      ) : null}
    </div>
  );
};

export default AllUsersTable;
